var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.miscellaneousCertification
    ? _c(
        "div",
        { staticClass: "miscellaneous-certification" },
        [
          _c(
            "v-sheet",
            { staticClass: "eqp-classification", attrs: { rounded: "" } },
            [
              _c(
                "v-row",
                [
                  _c("v-col", { staticClass: "py-0", attrs: { cols: "12" } }, [
                    _c("div", { staticClass: "text-h6" }, [
                      _vm._v("Miscellaneous Certification"),
                    ]),
                  ]),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-sheet",
                        { staticClass: "eqp-classification-inner mb-2" },
                        [
                          _c(
                            "v-tabs",
                            {
                              model: {
                                value: _vm.selectedMiscCertification,
                                callback: function ($$v) {
                                  _vm.selectedMiscCertification = $$v
                                },
                                expression: "selectedMiscCertification",
                              },
                            },
                            [
                              _c(
                                "v-tab",
                                {
                                  attrs: {
                                    "active-class": "tab-cable-active",
                                    "tab-value": "IntrinsicSafety",
                                    href: `#IntrinsicSafety`,
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          `Fields.EquipmentFields.IntrinsicSafety.Label`
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-tab",
                                {
                                  attrs: {
                                    "active-class": "tab-cable-active",
                                    "tab-value": "MotorRotatingElectricMachine",
                                    href: `#MotorRotatingElectricMachine`,
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          `Fields.EquipmentFields.MotorRotatingElectricMachine.Label`
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-tab",
                                {
                                  attrs: {
                                    "active-class": "tab-cable-active",
                                    "tab-value": "ExPInformation",
                                    href: `#ExPInformation`,
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          `Fields.EquipmentFields.ExPInformation.Label`
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-tab",
                                {
                                  attrs: {
                                    "active-class": "tab-cable-active",
                                    "tab-value": "ExeCurrentTransformer",
                                    href: `#ExeCurrentTransformer`,
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          `Fields.EquipmentFields.ExeCurrentTransformer.Label`
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-tab",
                                {
                                  attrs: {
                                    "active-class": "tab-cable-active",
                                    "tab-value": "ExeGeneralPurposeJunctionBox",
                                    href: `#ExeGeneralPurposeJunctionBox`,
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          `Fields.EquipmentFields.ExeGeneralPurposeJunctionBox.Label`
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-tabs-items",
                {
                  model: {
                    value: _vm.selectedMiscCertification,
                    callback: function ($$v) {
                      _vm.selectedMiscCertification = $$v
                    },
                    expression: "selectedMiscCertification",
                  },
                },
                [
                  _c(
                    "v-tab-item",
                    { attrs: { value: "ExeGeneralPurposeJunctionBox" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-title",
                                    {
                                      staticStyle: {
                                        "background-color": "#1c2f53",
                                        color: "white",
                                      },
                                    },
                                    [_vm._v(" Junction Box Terminal Blocks ")]
                                  ),
                                  _c(
                                    "v-card-text",
                                    [
                                      _vm.junctionBoxId
                                        ? _c(
                                            "JunctionBoxTerminalBlockComponent",
                                            {
                                              attrs: {
                                                "junction-box-id":
                                                  _vm.junctionBoxId,
                                                "read-only-flag":
                                                  _vm.readOnlyFlag,
                                              },
                                            }
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "text-center pa-4" },
                                            [
                                              _c("p", [
                                                _vm._v(
                                                  "No junction box selected"
                                                ),
                                              ]),
                                            ]
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-tab-item",
                    { attrs: { value: "ExeCurrentTransformer" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-title",
                                    {
                                      staticStyle: {
                                        "background-color": "#1c2f53",
                                        color: "white",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "SiteComponents.EquipmentDetails.ExeCurrentTransformer"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        { staticStyle: { height: "50px" } },
                                        [_c("v-spacer")],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("base-text-field", {
                                                staticClass: "flex-grow",
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .exEshortCircuitCurrent,
                                                  outlined: "",
                                                  placeholder: "",
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.ShortCircuitCurrent.Label"
                                                  ),
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "exEshortCircuitCurrent",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-tab-item",
                    { attrs: { value: "ExPInformation" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-title",
                                    {
                                      staticStyle: {
                                        "background-color": "#1c2f53",
                                        color: "white",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "SiteComponents.EquipmentDetails.ProtectionTypeExP"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        { staticStyle: { height: "50px" } },
                                        [_c("v-spacer")],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c("base-text-field", {
                                                staticClass: "flex-grow",
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .exPminPurgeFlow,
                                                  outlined: "",
                                                  placeholder: "",
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.MinPurgeFlow.Label"
                                                  ),
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "exPminPurgeFlow",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c("base-text-field", {
                                                staticClass: "flex-grow",
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .exPminPurgeDurartion,
                                                  outlined: "",
                                                  placeholder: "",
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.MinPurgeDuration.Label"
                                                  ),
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "exPminPurgeDurartion",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c("base-text-field", {
                                                staticClass: "flex-grow",
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .exPtypeOfProtectiveGas,
                                                  outlined: "",
                                                  placeholder: "",
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.TypeOfProtectiveGas.Label"
                                                  ),
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "exPtypeOfProtectiveGas",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c("v-col", { attrs: { cols: "6" } }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c("base-text-field", {
                                                staticClass: "flex-grow",
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .exPminOverpressure,
                                                  outlined: "",
                                                  placeholder: "",
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.MinOverpressure.Label"
                                                  ),
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "exPminOverpressure",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c("base-text-field", {
                                                staticClass: "flex-grow",
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .exPmaxOverpressure,
                                                  outlined: "",
                                                  placeholder: "",
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.MaxOverpressure.Label"
                                                  ),
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "exPmaxOverpressure",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c("base-text-field", {
                                                staticClass: "flex-grow",
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .exPminSupplyPressure,
                                                  outlined: "",
                                                  placeholder: "",
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.MinSupplyPressure.Label"
                                                  ),
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "exPminSupplyPressure",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c("base-text-field", {
                                                staticClass: "flex-grow",
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .exPmaxSupplyPressure,
                                                  outlined: "",
                                                  placeholder: "",
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.MaxSupplyPressure.Label"
                                                  ),
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "exPmaxSupplyPressure",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c("base-text-field", {
                                                staticClass: "flex-grow",
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .exPmaxLeakageRate,
                                                  outlined: "",
                                                  placeholder: "",
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.MaxLeakageRate.Label"
                                                  ),
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "exPmaxLeakageRate",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c("base-text-field", {
                                                staticClass: "flex-grow",
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .exPrangeOfTemprature,
                                                  outlined: "",
                                                  placeholder: "",
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.RangeOfTemperatureForProtectiveGas.Label"
                                                  ),
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "exPrangeOfTemprature",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c("base-text-field", {
                                                staticClass: "flex-grow",
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .exPpointsOfPressure,
                                                  outlined: "",
                                                  placeholder: "",
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.PointsOfPressure.Label"
                                                  ),
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "exPpointsOfPressure",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c("base-autocomplete", {
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  dense: "",
                                                  outlined: "",
                                                  items: _vm.selectYesNo,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .exPinternalSourceOfRelease,
                                                  "item-text": "value",
                                                  "item-value": "key",
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.InternalSourceOfRelease.Label"
                                                  ),
                                                  "return-object": false,
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "exPinternalSourceOfRelease",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.miscellaneousCertification
                                        .exPinternalSourceOfRelease === "yes"
                                        ? _c(
                                            "v-row",
                                            { staticClass: "center-row" },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticClass: "flex-grow",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlag,
                                                      value:
                                                        _vm
                                                          .miscellaneousCertification
                                                          .exPmaxInletPressure,
                                                      outlined: "",
                                                      placeholder: "",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.MaxInletPressure.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.miscellaneousCertification,
                                                          "exPmaxInletPressure",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticClass: "flex-grow",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlag,
                                                      value:
                                                        _vm
                                                          .miscellaneousCertification
                                                          .exPmaxFlowRate,
                                                      outlined: "",
                                                      placeholder: "",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.MaxFlowRate.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.miscellaneousCertification,
                                                          "exPmaxFlowRate",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-tab-item",
                    { attrs: { value: "MotorRotatingElectricMachine" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-title",
                                    {
                                      staticStyle: {
                                        "background-color": "#1c2f53",
                                        color: "white",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "SiteComponents.EquipmentDetails.MotorRotatingMachine"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        { staticStyle: { height: "50px" } },
                                        [_c("v-spacer")],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "center",
                                              attrs: { cols: "6" },
                                            },
                                            [
                                              _c("base-autocomplete", {
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  dense: "",
                                                  outlined: "",
                                                  items: _vm.selectYesNo,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .mOperatedConvertor,
                                                  "item-text": "value",
                                                  "item-value": "key",
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.OperatedWithConverter.Label"
                                                  ),
                                                  "return-object": false,
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "mOperatedConvertor",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c("v-col", {
                                            staticClass: "center",
                                            attrs: { cols: "6" },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm.miscellaneousCertification
                                        .mOperatedConvertor === "yes"
                                        ? _c(
                                            "v-row",
                                            { staticClass: "center-row" },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticClass: "flex-grow",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlag,
                                                      value:
                                                        _vm
                                                          .miscellaneousCertification
                                                          .mSpeedRangeLimitLow,
                                                      outlined: "",
                                                      placeholder: "",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.SpeedRangeLimitLow.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.miscellaneousCertification,
                                                          "mSpeedRangeLimitLow",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticClass: "flex-grow",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlag,
                                                      value:
                                                        _vm
                                                          .miscellaneousCertification
                                                          .mSpeedRangeLimitHigh,
                                                      outlined: "",
                                                      placeholder: "",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.SpeedRangeLimitHigh.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.miscellaneousCertification,
                                                          "mSpeedRangeLimitHigh",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.miscellaneousCertification
                                        .mOperatedConvertor === "yes"
                                        ? _c(
                                            "v-row",
                                            { staticClass: "center-row" },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticClass: "flex-grow",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlag,
                                                      value:
                                                        _vm
                                                          .miscellaneousCertification
                                                          .mFrequencyRangeLimitLow,
                                                      outlined: "",
                                                      placeholder: "",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.FrequencyRangeLimitLow.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.miscellaneousCertification,
                                                          "mFrequencyRangeLimitLow",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "6" } },
                                                [
                                                  _c("base-text-field", {
                                                    staticClass: "flex-grow",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlag,
                                                      value:
                                                        _vm
                                                          .miscellaneousCertification
                                                          .mFrequencyRangeLimitHigh,
                                                      outlined: "",
                                                      placeholder: "",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.FrequencyRangeLimitHigh.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.miscellaneousCertification,
                                                          "mFrequencyRangeLimitHigh",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c("base-text-field", {
                                                staticClass: "flex-grow",
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .mSwitchingFrequency,
                                                  outlined: "",
                                                  placeholder: "",
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.SwitchingFrequency.Label"
                                                  ),
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "mSwitchingFrequency",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c("base-autocomplete", {
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  dense: "",
                                                  outlined: "",
                                                  items: _vm.selectKhzMhz,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .mSwitchingFrequencyUnit,
                                                  "item-text": "value",
                                                  "item-value": "id",
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.SwitchingFrequencyUnit.Label"
                                                  ),
                                                  "return-object": false,
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "mSwitchingFrequencyUnit",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("base-autocomplete", {
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  dense: "",
                                                  outlined: "",
                                                  items: _vm.selectTorqueType,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .mTypeOfTorque,
                                                  "item-text": "value",
                                                  "item-value": "id",
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.TypeOfTorque.Label"
                                                  ),
                                                  "return-object": false,
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "mTypeOfTorque",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("base-text-field", {
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .mSpecificConverter,
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.SpecificConverter.Label"
                                                  ),
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "mSpecificConverter",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("base-text-field", {
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .mTypeOfConverter,
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.TypeOfConverter.Label"
                                                  ),
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "mTypeOfConverter",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("base-text-field", {
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .mExEbMotor,
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.ExEbMotor.Label"
                                                  ),
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "mExEbMotor",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("base-text-field", {
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .mIaIn,
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.IAIN.Label"
                                                  ),
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "mIaIn",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "12" } },
                                            [
                                              _c("base-text-field", {
                                                attrs: {
                                                  disabled: _vm.readOnlyFlag,
                                                  value:
                                                    _vm
                                                      .miscellaneousCertification
                                                      .mTeS,
                                                  label: _vm.$t(
                                                    "Fields.EquipmentFields.TeS.Label"
                                                  ),
                                                },
                                                on: {
                                                  "update:value": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.miscellaneousCertification,
                                                      "mTeS",
                                                      $event
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-tab-item",
                    { attrs: { value: "IntrinsicSafety" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c(
                                "v-card",
                                { attrs: { flat: "" } },
                                [
                                  _c(
                                    "v-card-title",
                                    {
                                      staticStyle: {
                                        "background-color": "#1c2f53",
                                        color: "white",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SiteComponents.EquipmentDetails.IntrinsicSafety"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-row",
                                        { staticStyle: { height: "50px" } },
                                        [_c("v-spacer")],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "center-column",
                                              attrs: { cols: "2" },
                                            },
                                            [
                                              _c(
                                                "h3",
                                                {
                                                  staticStyle: {
                                                    color: "#1c2f53",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "Field Equipment Parameters"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "center-column yellow-bg",
                                              attrs: { cols: "8" },
                                            },
                                            [
                                              _c("h3", {
                                                staticStyle: {
                                                  color: "#1c2f53",
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "center-column",
                                              attrs: { cols: "2" },
                                            },
                                            [
                                              _c(
                                                "h3",
                                                {
                                                  staticStyle: {
                                                    color: "#1c2f53",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "Associated Apparatus Parameters"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "center",
                                              attrs: { cols: "2" },
                                            },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _c("base-text-field", {
                                                    staticClass: "flex-grow",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlag ||
                                                        (!_vm.siteLocationsSrv.isEnabledField(
                                                          "junctionBoxFieldAssociatedApparatus",
                                                          ["FE", "FEA"]
                                                        ) &&
                                                          !_vm.siteLocationsSrv.isEnabledField(
                                                            "equipmentFieldEquipmentAssociatedApparatus",
                                                            ["FE", "FEA"]
                                                          )),
                                                      value:
                                                        _vm
                                                          .miscellaneousCertification
                                                          .fieldUiV,
                                                      outlined: "",
                                                      placeholder: "",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.UiV.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.miscellaneousCertification,
                                                          "fieldUiV",
                                                          $event
                                                        )
                                                      },
                                                      keypress:
                                                        _vm.validateNumber,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _c("v-col", {
                                            staticClass: "center yellow-bg",
                                            attrs: { cols: "8" },
                                          }),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "center",
                                              attrs: { cols: "2" },
                                            },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _c("base-text-field", {
                                                    staticClass: "flex-grow",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlag ||
                                                        (!_vm.siteLocationsSrv.isEnabledField(
                                                          "junctionBoxFieldAssociatedApparatus",
                                                          ["FEA", "AA"]
                                                        ) &&
                                                          !_vm.siteLocationsSrv.isEnabledField(
                                                            "equipmentFieldEquipmentAssociatedApparatus",
                                                            ["FEA", "AA"]
                                                          )),
                                                      value:
                                                        _vm
                                                          .miscellaneousCertification
                                                          .apparatusUoV,
                                                      outlined: "",
                                                      placeholder: "",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.UoV.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.miscellaneousCertification,
                                                          "apparatusUoV",
                                                          $event
                                                        )
                                                      },
                                                      keypress:
                                                        _vm.validateNumber,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "center",
                                              attrs: { cols: "2" },
                                            },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _c("base-text-field", {
                                                    staticClass: "flex-grow",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlag ||
                                                        (!_vm.siteLocationsSrv.isEnabledField(
                                                          "junctionBoxFieldAssociatedApparatus",
                                                          ["FE", "FEA"]
                                                        ) &&
                                                          !_vm.siteLocationsSrv.isEnabledField(
                                                            "equipmentFieldEquipmentAssociatedApparatus",
                                                            ["FE", "FEA"]
                                                          )),
                                                      value:
                                                        _vm
                                                          .miscellaneousCertification
                                                          .fieldIiMa,
                                                      outlined: "",
                                                      placeholder: "",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.IiMa.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.miscellaneousCertification,
                                                          "fieldIiMa",
                                                          $event
                                                        )
                                                      },
                                                      keypress:
                                                        _vm.validateNumber,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _c("v-col", {
                                            staticClass: "center yellow-bg",
                                            attrs: { cols: "8" },
                                          }),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "center",
                                              attrs: { cols: "2" },
                                            },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _c("base-text-field", {
                                                    staticClass: "flex-grow",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlag ||
                                                        (!_vm.siteLocationsSrv.isEnabledField(
                                                          "junctionBoxFieldAssociatedApparatus",
                                                          ["FEA", "AA"]
                                                        ) &&
                                                          !_vm.siteLocationsSrv.isEnabledField(
                                                            "equipmentFieldEquipmentAssociatedApparatus",
                                                            ["FEA", "AA"]
                                                          )),
                                                      value:
                                                        _vm
                                                          .miscellaneousCertification
                                                          .apparatusIoMa,
                                                      outlined: "",
                                                      placeholder: "",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.IoMa.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.miscellaneousCertification,
                                                          "apparatusIoMa",
                                                          $event
                                                        )
                                                      },
                                                      keypress:
                                                        _vm.validateNumber,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "center",
                                              attrs: { cols: "2" },
                                            },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _c("base-text-field", {
                                                    staticClass: "flex-grow",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlag ||
                                                        (!_vm.siteLocationsSrv.isEnabledField(
                                                          "junctionBoxFieldAssociatedApparatus",
                                                          ["FE", "FEA"]
                                                        ) &&
                                                          !_vm.siteLocationsSrv.isEnabledField(
                                                            "equipmentFieldEquipmentAssociatedApparatus",
                                                            ["FE", "FEA"]
                                                          )),
                                                      value:
                                                        _vm
                                                          .miscellaneousCertification
                                                          .fieldPiW,
                                                      outlined: "",
                                                      placeholder: "",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.PiW.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.miscellaneousCertification,
                                                          "fieldPiW",
                                                          $event
                                                        )
                                                      },
                                                      keypress:
                                                        _vm.validateNumber,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _c("v-col", {
                                            staticClass: "center yellow-bg",
                                            attrs: { cols: "8" },
                                          }),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "center",
                                              attrs: { cols: "2" },
                                            },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _c("base-text-field", {
                                                    staticClass: "flex-grow",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlag ||
                                                        (!_vm.siteLocationsSrv.isEnabledField(
                                                          "junctionBoxFieldAssociatedApparatus",
                                                          ["FEA", "AA"]
                                                        ) &&
                                                          !_vm.siteLocationsSrv.isEnabledField(
                                                            "equipmentFieldEquipmentAssociatedApparatus",
                                                            ["FEA", "AA"]
                                                          )),
                                                      value:
                                                        _vm
                                                          .miscellaneousCertification
                                                          .apparatusPoW,
                                                      outlined: "",
                                                      placeholder: "",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.PoW.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.miscellaneousCertification,
                                                          "apparatusPoW",
                                                          $event
                                                        )
                                                      },
                                                      keypress:
                                                        _vm.validateNumber,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "center",
                                              attrs: { cols: "2" },
                                            },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _c("base-text-field", {
                                                    staticClass: "flex-grow",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlag ||
                                                        (!_vm.siteLocationsSrv.isEnabledField(
                                                          "junctionBoxFieldAssociatedApparatus",
                                                          ["FE", "FEA"]
                                                        ) &&
                                                          !_vm.siteLocationsSrv.isEnabledField(
                                                            "equipmentFieldEquipmentAssociatedApparatus",
                                                            ["FE", "FEA"]
                                                          )),
                                                      value:
                                                        _vm
                                                          .miscellaneousCertification
                                                          .fieldCiuF,
                                                      outlined: "",
                                                      placeholder: "",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.CiuF.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.miscellaneousCertification,
                                                          "fieldCiuF",
                                                          $event
                                                        )
                                                      },
                                                      keypress:
                                                        _vm.validateNumber,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "center yellow-bg connectHead",
                                              attrs: { cols: "8" },
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "connectMid" },
                                                [
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c("v-col", {
                                                        attrs: { col: "2" },
                                                      }),
                                                      _c("v-col", {
                                                        attrs: { col: "2" },
                                                      }),
                                                      _c("v-col", {
                                                        attrs: { col: "2" },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "center",
                                              attrs: { cols: "2" },
                                            },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _c("base-text-field", {
                                                    staticClass: "flex-grow",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlag ||
                                                        (!_vm.siteLocationsSrv.isEnabledField(
                                                          "junctionBoxFieldAssociatedApparatus",
                                                          ["FEA", "AA"]
                                                        ) &&
                                                          !_vm.siteLocationsSrv.isEnabledField(
                                                            "equipmentFieldEquipmentAssociatedApparatus",
                                                            ["FEA", "AA"]
                                                          )),
                                                      value:
                                                        _vm
                                                          .miscellaneousCertification
                                                          .apparatusCouF,
                                                      outlined: "",
                                                      placeholder: "",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.CouF.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.miscellaneousCertification,
                                                          "apparatusCouF",
                                                          $event
                                                        )
                                                      },
                                                      keypress:
                                                        _vm.validateNumber,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticClass: "center-row" },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "center",
                                              attrs: { cols: "2" },
                                            },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _c("base-text-field", {
                                                    staticClass: "flex-grow",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlag ||
                                                        (!_vm.siteLocationsSrv.isEnabledField(
                                                          "junctionBoxFieldAssociatedApparatus",
                                                          ["FE", "FEA"]
                                                        ) &&
                                                          !_vm.siteLocationsSrv.isEnabledField(
                                                            "equipmentFieldEquipmentAssociatedApparatus",
                                                            ["FE", "FEA"]
                                                          )),
                                                      value:
                                                        _vm
                                                          .miscellaneousCertification
                                                          .fieldLiMh,
                                                      outlined: "",
                                                      placeholder: "",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.LiMh.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.miscellaneousCertification,
                                                          "fieldLiMh",
                                                          $event
                                                        )
                                                      },
                                                      keypress:
                                                        _vm.validateNumber,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "center yellow-bg connectHead",
                                              attrs: { cols: "8" },
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "connectMid" },
                                                [
                                                  _c(
                                                    "v-row",
                                                    [
                                                      _c("v-col", {
                                                        attrs: { col: "2" },
                                                      }),
                                                      _c("v-col", {
                                                        attrs: { col: "2" },
                                                      }),
                                                      _c("v-col", {
                                                        attrs: { col: "2" },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-col",
                                            {
                                              staticClass: "center",
                                              attrs: { cols: "2" },
                                            },
                                            [
                                              _c(
                                                "span",
                                                [
                                                  _c("base-text-field", {
                                                    staticClass: "flex-grow",
                                                    attrs: {
                                                      disabled:
                                                        _vm.readOnlyFlag ||
                                                        (!_vm.siteLocationsSrv.isEnabledField(
                                                          "junctionBoxFieldAssociatedApparatus",
                                                          ["FEA", "AA"]
                                                        ) &&
                                                          !_vm.siteLocationsSrv.isEnabledField(
                                                            "equipmentFieldEquipmentAssociatedApparatus",
                                                            ["FEA", "AA"]
                                                          )),
                                                      value:
                                                        _vm
                                                          .miscellaneousCertification
                                                          .apparatusLoMh,
                                                      outlined: "",
                                                      placeholder: "",
                                                      label: _vm.$t(
                                                        "Fields.EquipmentFields.LoMh.Label"
                                                      ),
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          _vm.miscellaneousCertification,
                                                          "apparatusLoMh",
                                                          $event
                                                        )
                                                      },
                                                      keypress:
                                                        _vm.validateNumber,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-row",
                                        { staticStyle: { height: "50px" } },
                                        [_c("v-spacer")],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }